export const locales = {
  'sl-SI': () => import('@angular/common/locales/sl'),
  'en-US': () => import('@angular/common/locales/en'),
  'de-DE': () => import('@angular/common/locales/de'),
  'ru-RU': () => import('@angular/common/locales/ru'),
  'hr-HR': () => import('@angular/common/locales/hr'),
  'it-IT': () => import('@angular/common/locales/it'),
  'sr-RS': () => import('@angular/common/locales/sr'),
  'tr-TR': () => import('@angular/common/locales/tr'),
};
